import React from 'react';
import ReactDOM from 'react-dom';

import './stylesheets/index.css'; // imports the index stylesheet file
import './stylesheets/fonts.css'; // imports the fonts

import App from  './App'; // imports the main App component, for displaying purposes, of course
ReactDOM.render(<App />, document.body);